import { render } from "./content.vue?vue&type=template&id=3ab1aa46&scoped=true"
const script = {}

import "./content.vue?vue&type=style&index=0&id=3ab1aa46&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab1aa46"]])

export default __exports__